import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  id: {
    // Header
    search_placeholder: "Cari produk...",
    cart: "Keranjang",
    all_categories: "Semua Kategori",
    location: "Lokasi",
    detecting_location: "Mendeteksi lokasi...",
    location_not_available: "Lokasi tidak tersedia",
    
    // Home
    hero_title: "Temukan Produk Terbaik",
    hero_subtitle: "Dari toko-toko terdekat di sekitar Anda",
    nearby_merchants: "Toko Terdekat",
    view_all: "Lihat Semua",
    load_more: "Muat Lebih Banyak",
    loading: "Memuat...",
    no_merchants: "Tidak ada toko ditemukan",
    no_products: "Tidak ada produk",
    
    // Product
    add_to_cart: "Keranjang",
    sold: "Terjual",
    open: "Buka",
    closed: "Tutup",
    products: "produk",
    
    // Cart
    cart_empty: "Keranjang kosong",
    cart_empty_desc: "Tambahkan produk ke keranjang",
    subtotal: "Subtotal",
    checkout: "Checkout",
    continue_shopping: "Lanjut Belanja",
    remove: "Hapus",
    
    // Checkout
    checkout_title: "Checkout",
    shipping_address: "Alamat Pengiriman",
    name: "Nama Lengkap",
    phone: "Nomor Telepon",
    address: "Alamat",
    city: "Kota",
    district: "Kecamatan",
    notes: "Catatan (opsional)",
    
    // Payment
    payment_method: "Metode Pembayaran",
    qris: "QRIS",
    bank_transfer: "Transfer Bank",
    cod: "Bayar di Tempat (COD)",
    select_bank: "Pilih Bank",
    
    // Order
    place_order: "Buat Pesanan",
    order_success: "Pesanan Berhasil!",
    order_number: "Nomor Pesanan",
    order_total: "Total Pesanan",
    back_to_home: "Kembali ke Beranda",
    processing: "Memproses...",
    
    // Categories
    cat_sembako: "Sembako",
    cat_minuman: "Minuman",
    cat_makanan: "Makanan",
    cat_bumbu: "Bumbu Dapur",
    cat_snack: "Makanan Ringan",
    cat_obat: "Obat-obatan",
    cat_elektronik: "Elektronik",
    cat_all: "Semua",
    cat_bahan: "Bahan Makanan",
    cat_pokok: "Kebutuhan Pokok",
    
    // Footer
    about_us: "Tentang Kami",
    contact: "Kontak",
    help: "Bantuan",
    privacy_policy: "Kebijakan Privasi",
    terms: "Syarat & Ketentuan",
    
    // Misc
    items: "item",
    from: "dari",
    distance: "Jarak",

    // Seller Onboarding
    seller_cta_badge: "Peluang Bisnis",
    seller_cta_title: "Mulai Berjualan di GIZI.AI",
    seller_cta_subtitle: "Jangkau lebih banyak pelanggan dengan bergabung sebagai mitra GIZI.AI",
    seller_cta_button: "Pelajari Caranya",
    seller_onboarding_title: "Cara Berjualan di GIZI.AI",
    seller_onboarding_hero_title: "5 Langkah Mudah Mulai Berjualan",
    seller_onboarding_hero_subtitle: "Ikuti panduan berikut untuk mendaftarkan toko Anda di GIZI.AI dan mulai menjangkau ribuan pelanggan.",
  },
  en: {
    // Header
    search_placeholder: "Search products...",
    cart: "Cart",
    all_categories: "All Categories",
    location: "Location",
    detecting_location: "Detecting location...",
    location_not_available: "Location not available",
    
    // Home
    hero_title: "Find the Best Products",
    hero_subtitle: "From nearby stores around you",
    nearby_merchants: "Nearby Stores",
    view_all: "View All",
    load_more: "Load More",
    loading: "Loading...",
    no_merchants: "No stores found",
    no_products: "No products",
    
    // Product
    add_to_cart: "Add to Cart",
    sold: "Sold",
    open: "Open",
    closed: "Closed",
    products: "products",
    
    // Cart
    cart_empty: "Cart is empty",
    cart_empty_desc: "Add products to your cart",
    subtotal: "Subtotal",
    checkout: "Checkout",
    continue_shopping: "Continue Shopping",
    remove: "Remove",
    
    // Checkout
    checkout_title: "Checkout",
    shipping_address: "Shipping Address",
    name: "Full Name",
    phone: "Phone Number",
    address: "Address",
    city: "City",
    district: "District",
    notes: "Notes (optional)",
    
    // Payment
    payment_method: "Payment Method",
    qris: "QRIS",
    bank_transfer: "Bank Transfer",
    cod: "Cash on Delivery (COD)",
    select_bank: "Select Bank",
    
    // Order
    place_order: "Place Order",
    order_success: "Order Successful!",
    order_number: "Order Number",
    order_total: "Order Total",
    back_to_home: "Back to Home",
    processing: "Processing...",
    
    // Categories
    cat_sembako: "Groceries",
    cat_minuman: "Beverages",
    cat_makanan: "Food",
    cat_bumbu: "Spices",
    cat_snack: "Snacks",
    cat_obat: "Medicine",
    cat_elektronik: "Electronics",
    cat_all: "All",
    cat_bahan: "Ingredients",
    cat_pokok: "Daily Needs",
    
    // Footer
    about_us: "About Us",
    contact: "Contact",
    help: "Help",
    privacy_policy: "Privacy Policy",
    terms: "Terms & Conditions",
    
    // Misc
    items: "items",
    from: "from",
    distance: "Distance",

    // Seller Onboarding
    seller_cta_badge: "Business Opportunity",
    seller_cta_title: "Start Selling on GIZI.AI",
    seller_cta_subtitle: "Reach more customers by joining as a GIZI.AI partner",
    seller_cta_button: "Learn How",
    seller_onboarding_title: "How to Sell on GIZI.AI",
    seller_onboarding_hero_title: "5 Easy Steps to Start Selling",
    seller_onboarding_hero_subtitle: "Follow this guide to register your store on GIZI.AI and start reaching thousands of customers.",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('marketplace_language');
    return saved || 'id';
  });

  useEffect(() => {
    localStorage.setItem('marketplace_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'id' ? 'en' : 'id');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
